import { Component, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

import { MediationService } from './mediation.service';
import { ICarouselOrder, MediationTableRow } from './mediation.model';
import { DropdownValue } from '../shared/dropdown.model';
import { ColorService } from '../shared/color-service';
import { StorageService } from "../core/services/index";
import { consts } from "../shared/consts";
import { MediationFilters } from "./mediation.filters";
import { CampaignsFilterModel } from "../campaigns/campaign-filter.model";
import { CustomHorizontalScrollService } from "../shared/custom-horizontal-scroll.service";
import { FilterService } from '../core/services/filter.service';

@Component({
    moduleId: module.id,
    templateUrl: 'mediation.component.html'
})
export class MediationComponent implements AfterViewInit, OnDestroy {
    newWindow: Window;
    countryValues: Array<DropdownValue> = [];
    countryPrefix: string = 'Country';
    disabledCountrySelection: boolean = true;
    disabledFilter: boolean = true;
    disabledSaveChanges: boolean = true;
    resetSelectionOnValuesChanged: boolean = true;
    carouselItems: Array<ICarouselOrder> = [];
    tableRows: Array<MediationTableRow> = [];
    fallbackTableRows: Array<MediationTableRow> = [];
    private publisherId: number = 0;
    private countryId: number = 0;
    private providerId: number = 0;
    private inXhrGetCarouselOrder: any;
    private filters: MediationFilters;

    @ViewChild('tableBody') el: ElementRef;

    constructor(
        private mediationService: MediationService,
        private colorService: ColorService,
        private storageService: StorageService,
        private filterService: FilterService,
        private scrollService: CustomHorizontalScrollService) {
    }

    ngAfterViewInit() {
        var fixHelper = function (e, ui) {
            ui.children().each(function () {
                $(this).width($(this).width());
            });
            return ui;
        }
        var $tableBody = $(this.el.nativeElement);
        $tableBody.sortable({
            helper: fixHelper
        }).disableSelection();
    }

    onPublisherValueChanged(item: DropdownValue) {
        this.disabledCountrySelection = true;
        this.disabledFilter = true;
        this.disabledSaveChanges = true;
        this.publisherId = item.value;
        this.mediationService.getCountriesByPublisher(item.value).subscribe((response) => {
            let countries = response.json();
            this.countryValues = [];
            if (countries && countries.length > 0)
                for (let country of countries)
                    this.countryValues.push(new DropdownValue(country.id, country.countryName));
            this.disabledFilter = true;
        }, () => { }, () => { this.disabledCountrySelection = false; })
    }

    onCountryValueChanged(item: DropdownValue) {
        this.countryId = item.value;
        this.disabledFilter = false;
    }

    onFilter(event) {
        this.disabledFilter = true;
        this.disabledSaveChanges = true;
        if (this.inXhrGetCarouselOrder) {
            this.inXhrGetCarouselOrder.unsubscribe();
        }
        let filters = new MediationFilters();
        filters.publisherId = this.publisherId;
        filters.countryId = this.countryId;

        this.storageService.set(consts.MediationFilterStorageKey, filters);
        this.populateTableWithCarouselOrderItems();
    }

    onResize(event) {
        this.toggleHorizontalScroll();
    }

    private toggleHorizontalScroll() {
        let self = this;
        setTimeout(function () {
            self.scrollService.toggleHorizontalScroll();
        }, 10);
    }

    onSaveChanges(event) {
        this.disabledSaveChanges = true;
        let $tableBody = $(this.el.nativeElement);
        let inputs = $tableBody.find('input');
        let ids: Array<number> = [];
        for (var i = 0; i < inputs.length; i++)
            ids.push($(inputs[i]).val());
        let self = this;
        this.mediationService.updateCarouselOrder(ids).subscribe(() => {
            self.populateTableWithCarouselOrderItems();
        });
    }

    private populateTableWithCarouselOrderItems() {
        this.inXhrGetCarouselOrder = this.mediationService.getCarouselOrder(this.publisherId, this.countryId).subscribe((response) => {
            let carousel = response.json();
            let fallback = carousel.filter(x => x.isFallbackProvider == true);
            this.fallbackTableRows.splice(0, this.fallbackTableRows.length);
            fallback.forEach(element => {
                let rowColor = this.getRowColor(element);
                let row = new MediationTableRow(element, element.isFallbackProvider, rowColor, this.getTextColor(rowColor), this.getFontStyle(element));
                this.fallbackTableRows.push(row);
            });
            this.carouselItems = carousel;
            this.tableRows.splice(0, this.tableRows.length);
            carousel.forEach(element => {
                if (element.isFallbackProvider == false) {
                    let rowColor = this.getRowColor(element);
                    let row = new MediationTableRow(element, false, rowColor, this.getTextColor(rowColor), this.getFontStyle(element));
                    this.tableRows.push(row);
                }
            });
        }, () => { }, () => { this.disabledFilter = false; this.disabledSaveChanges = false; this.toggleHorizontalScroll(); })
    }

    onShowCampaigns(event, providerName, isLive) {
        this.newWindow = window.open('', '_blank');
        this.mediationService.getProviderByName(providerName).subscribe((response) => {
            this.providerId = response.json().id;
            let filters = new MediationFilters();
            filters.countryId = this.countryId;
            filters.providerId = this.providerId;
            filters.isLive = isLive;
            filters.publisherId = this.publisherId;
            //open new campaigns tab with filters already set
            this.storageService.set(consts.MediationFilterStorageKey, filters);
            this.newWindow.location.href = '#/campaigns/mediation';
        }, () => { }, () => { })
    }

    private getRowColor(item): string {
        if (item.isLive)
            return this.colorService.getColorByName(item.providerName);
        return this.colorService.getColorByName('NotLive');
    }

    private getTextColor(rowColor): string {
        let textColor = '#000';
        var rgbValues = rowColor.replace('rgba(', '').replace(')', '').split(', ');
        if (rgbValues.length && rgbValues.length > 3) {
            var o = Math.round(((parseInt(rgbValues[0], 10) * 299) + (parseInt(rgbValues[1], 10) * 587) + (parseInt(rgbValues[2], 10) * 114)) / 1000);
            if (o > 125) {
                textColor = '#000';
            } else {
                textColor = '#fff';
            }
        }
        return textColor;
    }

    private getFontStyle(item): string {
        if (!item.isLive)
            return "italic";
        return 'normal';
    }

    ngOnDestroy() {
        if (this.inXhrGetCarouselOrder) {
            this.inXhrGetCarouselOrder.unsubscribe();
        }
        this.tableRows.splice(0, this.tableRows.length);
        this.fallbackTableRows.splice(0, this.fallbackTableRows.length);
        this.scrollService.toggleHorizontalScroll(false);
    }
}


// WEBPACK FOOTER //
// ./src/app/mediation/mediation.component.ts